module.exports = __webpack_public_path__ + "img/[乒乓球].bd8e8a72.svg";